<p-confirmDialog icon="pi pi-exclamation-triangle" acceptLabel="Si" rejectLabel="No"></p-confirmDialog>
<app-visor/>
<section>
    <main *ngIf="solicitudInfo" class="grid col-12">
        <div class="col-12 bg-blue-brand border-round-xl align-items-center inline-flex mb-1">
            <div class="border-round-3xl bg-white mx-4">
                <i class="pi pi-check text-custom-blue font-bold text-lg m-1"></i>
            </div>
            <p class="text-xl font-bold text-white">{{ solicitudInfo.actividadDescipcion }}</p>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.radicado}} #</b>
            </div>
            <div>
                <p>{{solicitudInfo.radicado}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-8">
            <div>
                <b>{{trans.tipo}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.tipo}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.dependencia}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.dependencia}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-8">
            <div>
                <b>{{trans.tipoDeTramite}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.tipoTramite}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.tema}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.solicitudTema}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-8">
            <div>
                <b>{{trans.descripcion}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.solicitudDescripcion}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.orden}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.actividadOrden}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.fechaInicioPlanificada}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.fechaPlanificadaInicio | date:defaultDateFormat}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.fechaCierrePlanificada}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.fechaPlanificadaCierre | date:defaultDateFormat}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.fechaInicioReal}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.fechaRealInicio | date:defaultDateFormat}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.fechaFinalizacionReal}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.fechaRealCierre | date:defaultDateFormat}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.estadoDeLaActividad}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.tramEstadosActividadId}}</p>
            </div>
        </div>


        <div class="col-12 md:col-6 lg:col-4">
            <div>
                <b>{{trans.medioRecepcion}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.medioRecepcion}}</p>
            </div>
        </div>

        <div class="col-12 md:col-6 lg:col-8">
            <div>
                <b>{{trans.descripcionMedioRecepcion}}:</b>
            </div>
            <div>
                <p>{{solicitudInfo.descripcionNotificacion}}</p>
            </div>
        </div>
        @if(solicitudInfo.documentoNombre){
        <div class="col-12 md:col-6 lg:col-8">
            <div>
                <b>{{trans.documento}}:</b>
            </div>
            <div class="flex gap-2 align-items-center">
                <i class="pi pi-file-pdf" style="font-size: 1.5rem; color:crimson"></i>
                <div>
                    {{ solicitudInfo.documentoNombre }}
                </div>
                <button pButton icon="pi pi-desktop" [label]="trans.abrir"
                    (click)="downloadFormFile(false)"
                    [disabled]="!ls.hasRole(role.GESTION_PQRSD)"></button>
                <button pButton icon="pi pi-download" [label]="trans.descargar" class="p-button-success"
                    (click)="downloadFormFile(true)"
                    [disabled]="!ls.hasRole(role.GESTION_PQRSD)"></button>
            </div>
        </div>
        }

        <div class="col-12 md:col-6 lg:col-4">
			<div>
				<b>{{trans.usuarioAsignado}}:</b>
			</div>
			<div>
				<p-dropdown [options]="usuariosValidos" appendTo="body" placeholder="Usuario..."
					[(ngModel)]="selectedUsuarioIdValido" optionLabel="correo" optionValue="id"
					(onChange)="onUsuarioValidoChange($event)"
					[disabled]="!ls.hasRole(role.ADMIN_PQRSD) || solicitudInfo.tramEstadosActividadId !== 'PENDIENTE'">
				</p-dropdown>
			</div>
		</div>

        <div class="col-12 pl-0 pr-0">
            <form [formGroup]="seguimientoForm" *ngIf="seguimientoForm">
                <div class="col-12">
                    <div>
                        <b>{{trans.seguimiento}}:</b>
                    </div>
                    <div>
                        <textarea rows="5" pInputTextarea formControlName="comentario" class="w-full"></textarea>
                        <ng-container
                            *ngIf="seguimientoForm.get('comentario')?.invalid && seguimientoForm.get('comentario')?.touched">
                            <app-form-group-error-message
                                [control]="seguimientoForm.get('comentario')"></app-form-group-error-message>
                        </ng-container>
                    </div>
                </div>

                <div class="col-12">
                    <div>
                        <b>{{trans.documento}}:</b>
                    </div>
                    <div>
                        <p-fileUpload #fileUpload 
                            mode="advanced" 
                            accept="application/pdf"
                            [maxFileSize]="uploadFileSize" 
                            [chooseLabel]="trans.agregarDocumento" 
                            chooseIcon="pi pi-upload"
                            [customUpload]="true" 
                            [auto]="true" 
                            [multiple]="true">
                        </p-fileUpload>
                    </div>
                </div>
            </form>
        </div>

        <div class="col-12 md:col-6 lg:col-4">
            <button pButton type="button" [label]="trans.finalizarActividad" class="p-button-success p-button-outlined w-full"
                icon="pi pi-fast-forward" (click)="finalizarActividad()"></button>
        </div>
        <div class="col-12 md:col-6 lg:col-4">
            <button pButton type="submit" [label]="trans.guardarSeguimiento" icon="pi pi-save" class="p-button-outlined w-full"
                (click)="onSubmitSeguimiento($event)"></button>
        </div>
        <div class="col-12 md:col-6 lg:col-4"
            *ngIf="solicitudInfo.tramEstadosActividadId === 'FINALIZADO' 
            && !(solicitudInfo.solicitudEstado === 'FINALIZADO' || solicitudInfo.solicitudEstado === 'RECHAZADO')">
			<button pButton type="button" [label]="trans.reabrirActividad" class="p-button-help p-button-outlined w-full"
				icon="pi pi-lock-open" (click)="reabrirActividadConfirm($event)"
				[disabled]="!ls.hasRole(role.ADMIN_PQRSD)"></button>
		</div>
        <div class="col-12 md:col-6 lg:col-4" *ngIf="solicitudInfo.tramEstadosActividadId === 'PENDIENTE' ">
			<button pButton type="button" [label]="trans.rechazarTramite" class="p-button-danger p-button-outlined w-full"
				icon="pi pi-thumbs-down" (click)="openRechazarModal()" [disabled]="!ls.hasRole(role.ADMIN_PQRSD)"></button>
		</div>

    </main>
</section>


<section>
	<form [formGroup]="rechazarForm" (ngSubmit)="onSubmitRechazarForm()">
		<p-dialog header="Rechazar Actividad" [(visible)]="displayRechazarModal" [modal]="true"
			[breakpoints]="{'960px': '100vw'}" [style]="{width: '85vw'}" [draggable]="false" [resizable]="true"
			[maximizable]="true">
			<div class="grid">
				<div class="field col-12 flex flex-column">
					<label for="observaciones">{{trans.observaciones}}<span style="color: red">*</span></label>
					<textarea rows="5" cols="60" pInputTextarea formControlName="observaciones"></textarea>
					<ng-container
						*ngIf="rechazarForm.get('observaciones')?.invalid && rechazarForm.get('observaciones')?.touched">
						<app-form-group-error-message [control]="rechazarForm.get('observaciones')"></app-form-group-error-message>
					</ng-container>
				</div>
			</div>
			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-between">
						<button pButton type="button" [label]="trans.limpiar" iconPos="right" icon="pi pi-eraser"
							(click)="resetRechazarForm()"></button>
						<button pButton type="submit" [label]="trans.guardar" icon="pi pi-save" iconPos="right"
							[disabled]="!ls.hasRole(role.ADMIN_PQRSD)"
							[pTooltip]="trans.requiereRolSeguridad" [tooltipDisabled]="ls.hasRole(role.ADMIN_PQRSD)" tooltipPosition="top"></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>
	</form>
</section>